import { EntityState } from '@/api/resources/entityState/entity-state'
import { shipmentsAuxiliaryService } from '@/modules/shipments-module/services/auxiliary/shipments-auxiliary.service'
import { EntityStatusState, StoreStateModel } from '@/store/root/root-store.model'
import { keyBy, merge } from 'lodash'
import { store } from '@/store/store'

export const SHIPMENT_REQUEST_STATES = {
    AWAITING_SHIPMENT: { code: 'AWAITING_SHIPMENT', class: 'state-pending', order: 10 },
    IN_SHIPMENT: { code: 'IN_SHIPMENT', class: 'state-shipment', order: 20 },
    SHIPMENT_FINISHED: { code: 'SHIPMENT_FINISHED', class: 'state-alt-success-1', order: 30 }
}

class ShipmentEntityState extends EntityState {
    protected get entityName(): string {
        return 'shipment-request'
    }

    async loadStates(): Promise<void> {
        if (!this.states.length) {
            const shipmentRequestStatuses = await shipmentsAuxiliaryService.getShipmentRequestStatuses()
            const states: EntityStatusState[] =
                shipmentRequestStatuses.map(shipmentRequestStatus => ({
                    code: shipmentRequestStatus.code,
                    name: shipmentRequestStatus.translatedName
                }))
            const entityState: StoreStateModel<EntityStatusState[]> = {
                name: this.entityName,
                state: Object.values(
                    merge(
                        keyBy(states, 'code'),
                        keyBy(SHIPMENT_REQUEST_STATES, 'code')))
            }
            await store.dispatch('setEntityState', entityState)
        }
    }
}

export const shipmentRequestState = new ShipmentEntityState()
